<template>
    <div>
        <nav-breadcrumb :menu="[{label: messageId ? '编辑留言' : '新增留言'}]"/>
        <el-row>
            <el-col>
                <panel label="基本信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="24">
                                <el-form-item label="接受者：" prop="m__recipientId" :rules="{required: true, message: '接受者不能为空'}" style="width: 60%">
                                    <el-select v-model="dataForm.m__branchId" placeholder="请选择分公司">
                                        <el-option :label="item.label" :value="item.value" v-for="(item,idx) in branchOptions" :key="idx"></el-option>
                                    </el-select>
                                    <el-select v-model="dataForm.m__recipientId" placeholder="请选择接受者">
                                        <el-option :label="item.label" :value="item.value" v-for="(item,idx) in branchUserOptions" :key="idx"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                            <el-col :span="24">
                                <el-form-item label="留言内容：" prop="m__content" :rules="{required: true, message: '留言内容不能为空'}" style="width: 60%">
                                    <el-input type="textarea" v-model="dataForm.m__content" style="margin-bottom:10px;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="tr xzmt">
                            <el-button type="primary" @click="onSubmit('dataForm')">确认提交</el-button>
                            <el-button @click="$router.back()">取消</el-button>
                        </div>
                    </el-form>
                </panel>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    export default {
        name: "BranchMessageAdd",
        data() {
            return {
                messageId:this.$route.query['messageId']||'',
                dataForm:{
                    m__recipientId:'',
                    m__recipientName:'',
                },
                dataFormRules:{},
                branchOptions:[],
                branchUserOptions:[],
            }
        },
        mounted() {
            if(this.messageId){
                this.getData()

            }
            this.getDataBranchOfficeSelect()
        },
        watch:{
            'dataForm.m__branchId':function () {
                this.getDataBranchUserSelect()
            },
            'dataForm.m__recipientId':function (newVal) {
                this.dataForm.m__recipientName = (this.branchUserOptions.filter(item => item.value == newVal)[0] || {}).label
            }
        },
        methods:{
            getData:function(){
                xhr.getBranchMessage({
                        'm.messageId': this.messageId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.dataForm = res.data.data
                            }
                        }catch (e) {

                        }
                    })
            },
            getDataBranchOfficeSelect: function () {
                xhr.getDataBranchOfficeSelect(
                    Object.assign({}, {}, {}),
                    res=> {
                        try {
                            this.branchOptions = res.data.data.map(item=>{
                                return {
                                    label: item.bo__branchName,
                                    value:item.bo__branchId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            getDataBranchUserSelect: function () {
                xhr.getDataBranchUserSelect(
                    Object.assign({
                        'bo.branchId':this.dataForm.m__branchId
                    }, {}, {}),
                    res=> {
                        try {
                            this.branchUserOptions = res.data.data.map(item=>{
                                return {
                                    label: item.du__userCode,
                                    value:item.du__userId,
                                }
                            })

                            this.dataForm.m__recipientId = (this.branchUserOptions.filter(item => item.value == this.dataForm.m__recipientId)[0] || {}).value||''
                        }catch(e){

                        }
                    })

            },
            onSubmit: function (formName) {
                let dataForm = this.dataForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        dataForm.m__checked = true
                        xhr.createBranchMessage(dataForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    this.$router.push({
                                        name: 'BranchMessageListView'
                                    })
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchMessageAdd.vue